import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';

import {
	ALL_CLASSIFICATION_LABEL,
	ALL_CLASSIFICATION_OPTION,
	EXTRA_BOARD_CLASSIFICATION_LABEL,
	EXTRA_BOARD_CLASSIFICATION_OPTION,
	REGULAR_CLASSIFICATION_LABEL,
	REGULAR_CLASSIFICATION_OPTION,
} from './const';

const options = [
	{ value: ALL_CLASSIFICATION_OPTION, text: ALL_CLASSIFICATION_LABEL },
	{ value: EXTRA_BOARD_CLASSIFICATION_OPTION, text: EXTRA_BOARD_CLASSIFICATION_LABEL },
	{ value: REGULAR_CLASSIFICATION_OPTION, text: REGULAR_CLASSIFICATION_LABEL },
];

const OperatorTypeFilter = ({ fieldControl, submitOnChange }) => {
	const renderOptions = (options) => {
		return options.map((option, index) => (
			<SelectOption key={index} value={option.value}>
				{option.text}
			</SelectOption>
		));
	};

	const handleOnSelect = (e) => {
		const value = e.target.value;
		fieldControl.onChange(value);
		submitOnChange();
	};

	return (
		<Select
			id="classification"
			label="Classification"
			value={fieldControl.value || EXTRA_BOARD_CLASSIFICATION_OPTION}
			onChange={(e) => handleOnSelect(e)}
		>
			{renderOptions(options)}
		</Select>
	);
};

export default OperatorTypeFilter;
